<!-- <button (click)="test()">Test</button> -->
<div class="container mt-3 mb-3">
    <div class="card" *ngIf="formulario">
        <div class="card-header">
            Platillos
        </div>
        <div class="card-body">
            <form [formGroup]="forma" (ngSubmit)='guardar()' role="form" novalidate>
                <div class="row">
                    <div class="col-md-3 text-center">
                        <label>Foto:</label>
                        <img [src]="image" alt="" class="img-thumbnail">
                        <input type="text" formControlName="url" hidden="true">

                        <!-- Button trigger modal -->
                        <button type="button" class="btn btn-primary mt-2" data-toggle="modal" data-target="#GaleriaModal">
                            Seleccionar Imagen
                        </button>
                    </div>
                    <div class="col-md-9">
                        <div class="row">
                            <div class="col-md-8">
                                <label>Título:</label>
                                <input formControlName="title" class="form-control" type="text" (focus)="$event.target.select()">
                            </div>
                            <div class="col-md-4">
                                <label>Precio:</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">$</div>
                                    </div>
                                    <input formControlName="price" type="number" min=1 class="form-control" (focus)="$event.target.select()">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <label>Descripcion:</label>
                                <textarea formControlName="description" class="form-control" type="text" (focus)="$event.target.select()"></textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <label>Categoría:</label>
                                <select id="ctrlSelectCategoria" class="form-control" (change)="selectCategoria($event)">
                                    <option value=0 selected>[ Selecciona una categoria ]</option>
                                    <option [value]="item.uid" *ngFor="let item of ds_categorias">{{ item.categoria | titlecase }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right mt-5">
                        <button type="button" class="btn btn-secondary mr-3" (click)="cancelar()"> <i class="far fa-cancel"></i> Cancelar</button>
                        <button type="submit" class="btn btn-primary" [disabled]="!forma.valid"> <i class="far fa-save"></i> Guardar</button>
                    </div>
                </div>
            </form>
        </div>
        <div class="card-footer">

        </div>
    </div>


    <div class="card mt-3">
        <div class="card-header">
            <div class="row">
                <div class="col-sm-12 text-right">
                    <button class="btn btn-success" (click)="nuevo()"> <i class="fas fa-plus"></i> Nuevo Platillo</button>
                </div>
            </div>
        </div>
        <div class="card-body">

            <table class="table table-responsive-md">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Título</th>
                        <th scope="col">Precio</th>
                        <th scope="col">Categoria</th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let item of ds_platillos">
                        <td>{{ item.title | titlecase }}</td>
                        <td>{{ item.price | currency:"MXN" }}</td>
                        <td>{{ item.category.categoria | titlecase }}</td>
                        <td> <button class="btn btn-warning" (click)='editar(item)'> <i class="far fa-edit"></i> Editar</button> </td>
                        <td> <button class="btn btn-danger" (click)='eliminar(item)'> <i class="far fa-trash-alt"></i> Eliminar </button> </td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</div>

<!-- Galería Modal -->



<!-- Modal -->
<div class="modal fade" id="GaleriaModal" tabindex="-1" aria-labelledby="GaleriaModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="GaleriaModalLabel">Galería</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <app-gallery (objSeleccionado)="getImageData($event)"></app-gallery>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>